module.exports = __webpack_public_path__ + "img/Session icon.82e3b85f.svg";